<template>
  <div class="hubspot-connect">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h1 class="mt-0 mb-0">
        {{ $t('developer-tab.hubspot-credentials.title') }}
      </h1>
    </div>

    <div class="hubspot-card">
      <div class="hubspot-card-content">
        <div class="hubspot-logo-container">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
            class="hubspot-logo"
          >
            <path
              fill="#ff7a59"
              d="M267.4 211.6c-25.1 23.7-40.8 57.3-40.8 94.6 0 37.3 15.7 70.9 40.8 94.6l-20.8 20.8c-31.8-30-51.5-72.5-51.5-119.1s19.7-89.1 51.5-119.1l20.8 20.8zm97.2-36.6l-20.8 20.8c25.1 23.7 40.8 57.3 40.8 94.6 0 37.3-15.7 70.9-40.8 94.6l20.8 20.8c31.8-30 51.5-72.5 51.5-119.1s-19.7-89.1-51.5-119.1zM256 256l-48-48v96l48-48zm128 0c0-70.7-57.3-128-128-128-40.3 0-76.2 18.6-99.7 47.7l29.7 29.7C200.7 185.8 226.8 172 256 172c46.3 0 84 37.7 84 84s-37.7 84-84 84c-29.2 0-55.3-13.8-70-35.4l-29.7 29.7C179.8 363.4 215.7 382 256 382c70.7 0 128-57.3 128-128z"
            />
          </svg>
        </div>

        <h2 class="hubspot-card-title">
          {{ $t('developer-tab.hubspot-credentials.connect-title') }}
        </h2>

        <p class="hubspot-card-description">
          {{ $t('developer-tab.hubspot-credentials.connect-description') }}
        </p>

        <div class="hubspot-features">
          <div class="feature-item">
            <i class="fa fa-check-circle feature-icon"></i>
            <span>{{
              $t('developer-tab.hubspot-credentials.features.contacts')
            }}</span>
          </div>
          <div class="feature-item">
            <i class="fa fa-check-circle feature-icon"></i>
            <span>{{
              $t('developer-tab.hubspot-credentials.features.companies')
            }}</span>
          </div>
          <div class="feature-item">
            <i class="fa fa-check-circle feature-icon"></i>
            <span>{{
              $t('developer-tab.hubspot-credentials.features.deals')
            }}</span>
          </div>
          <div class="feature-item">
            <i class="fa fa-check-circle feature-icon"></i>
            <span>{{
              $t('developer-tab.hubspot-credentials.features.tickets')
            }}</span>
          </div>
        </div>

        <button class="btn btn-hubspot" @click="connectToHubspot">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            class="btn-icon"
          >
            <path
              fill="currentColor"
              d="M18.164 10.997c.083-.287.13-.59.13-.903V8.54a2.087 2.087 0 0 0 1.202-1.89c0-1.153-.934-2.087-2.087-2.087s-2.087.934-2.087 2.087c0 .838.494 1.56 1.205 1.89v1.554c0 .314.046.617.13.903a4.94 4.94 0 0 0-1.826 1.09l-4.985-3.877a2.54 2.54 0 0 0 .137-.806 2.563 2.563 0 0 0-2.563-2.563 2.563 2.563 0 0 0-2.563 2.563 2.563 2.563 0 0 0 2.563 2.563c.547 0 1.05-.172 1.466-.463l4.982 3.874a4.971 4.971 0 0 0-.574 2.307c0 2.734 2.194 4.954 4.916 4.954s4.916-2.22 4.916-4.954c0-2.188-1.407-4.039-3.362-4.688zm-.755 7.565c-1.593 0-2.891-1.294-2.891-2.888 0-1.593 1.298-2.888 2.891-2.888 1.594 0 2.892 1.295 2.892 2.888 0 1.594-1.298 2.888-2.892 2.888z"
            />
          </svg>
          {{ $t('developer-tab.hubspot-credentials.connect-button') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HubspotConnect',
  data() {
    return {
      hubspotOAuthUrl:
        'https://app-eu1.hubspot.com/oauth/authorize?client_id=f0db8431-59a8-4f30-b964-cff3c3b2b978&redirect_uri=https%3A%2F%2Fwebhook.site%2Fbc4a088a-bb51-48b0-812e-0a84ccf20a3d%2Foauth%2Fcallback&scope=tickets%20crm.objects.contacts.write%20crm.schemas.contacts.write%20crm.schemas.deals.read%20oauth%20crm.objects.owners.read%20crm.objects.companies.write%20files%20crm.objects.companies.read%20crm.objects.deals.read%20crm.schemas.contacts.read%20crm.objects.contacts.read&optional_scope=crm.extensions_calling_transcripts.read%20automation%20crm.extensions_calling_transcripts.write%20conversations.custom_channels.read%20conversations.custom_channels.write'
    }
  },
  methods: {
    connectToHubspot() {
      window.open(this.hubspotOAuthUrl, '_blank')
    }
  }
}
</script>

<style scoped lang="scss">
.hubspot-connect {
  max-width: 800px;
  margin: 0 auto;
}

.hubspot-card {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

.hubspot-card-content {
  padding: 40px;
  text-align: center;
}

.hubspot-logo-container {
  margin-bottom: 24px;
}

.hubspot-logo {
  width: 80px;
  height: 80px;
}

.hubspot-card-title {
  font-size: 24px;
  font-weight: 600;
  color: #2d3748;
  margin-bottom: 12px;
}

.hubspot-card-description {
  font-size: 16px;
  color: #718096;
  margin-bottom: 32px;
  line-height: 1.6;
}

.hubspot-features {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-bottom: 32px;
  text-align: left;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #4a5568;
}

.feature-icon {
  color: #ff7a59;
  font-size: 16px;
}

.btn-hubspot {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background-color: #ff7a59;
  color: #ffffff;
  border: none;
  border-radius: 8px;
  padding: 14px 32px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.2s ease;

  &:hover {
    background-color: #ff5c35;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
}

.btn-icon {
  width: 20px;
  height: 20px;
}
</style>
